import axios from "axios"
import { envF } from "../../../../env";
import renderGlobalAlert from "../../../../system/hooks/useGlobalAlert";

export interface IModelRequest {
    idFileGlobal: string
}

export const marketContractRequest = async (
    modelRequest: IModelRequest,
    setIsSubmitting: (value: boolean) => void

) => {
    const jwtToken = localStorage.getItem("TokenData") as string;
    const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;
    const header = {
        headers: {
            Authorization: token
        },
    }

    const generateRequestUrl = (url: string) => {
        return `${envF.REACT_APP_API_GATEWAY_PATH}/` + url
    }
    setIsSubmitting(true)
    const result = await axios.post<boolean[]>(
        generateRequestUrl('ImportFiles/ImportMarketing/ImportCsv'),
        modelRequest,
        header
    )

    if (!result) renderGlobalAlert({
        variant: "exception",
        title: "Ошибка импорта",
        statusCode: 500,
    })
    
    setIsSubmitting(false)
    return result
}
